import script from "./BlockPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockPartners.vue?vue&type=script&setup=true&lang=js"

import "./BlockPartners.vue?vue&type=style&index=0&id=207c49a5&lang=scss"

const __exports__ = script;

export default __exports__